export default __webpack_public_path__ + "static/media/AceBgMobile.41c97d62.png";